module.exports = __webpack_public_path__ + "img/feature_buy.8025418b.png";